import React, {useContext, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import DesktopViewContext from "../context/DesktopViewContext";
import NewClientRequest from "./NewClientRequest";
const UpdateCompany = ({ }) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const {desktopView} = useContext(DesktopViewContext);
  const [isLoading, setIsLoading] = useState(true);
  const [companyName, setCompanyName] = useState("");
  const [companyLocation, setCompanyLocation] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [email, setEmail] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log(`Selected file size: ${file.size} bytes`);

      const reader = new FileReader();

      reader.onloadend = (ev) => {
        const arrayBuffer = reader.result;
        let logoAsBase64 = btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
        setSelectedFile(logoAsBase64);
      }

      reader.readAsArrayBuffer(file);
    }
  };
  
  
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(api_endpoint + "/api/user/company", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(user),
        });
        const fetchedData = await response.json();
        setCompanyLocation(fetchedData.location);
        setCompanyLogo(fetchedData.logo);
        setCompanyName(fetchedData.name);
        setEmail(fetchedData.email);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };
    if(user) fetchCompany();
  }, [user]);

  const navigateToCreateJob = () => {
    navigate("/createjob"); 
  };
  const handleSubmit = async () => {
    try {
      const companyData = {
        user: user,
        companyLogo,
        companyName,
        companyLocation,
        email,
        selectedFile,
      };

      const response = await fetch(api_endpoint + "/api/company", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(companyData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Company created successfully:", result);
        navigateToCreateJob();
      } else {
        console.error("Error creating company:", response.statusText);
      }
    } catch (error) {
      console.error("Error during company submission:", error);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (user && (user.type == "poster" || user.type == "admin")) {
    return (
      <div className="job-apply-container">
        <h3>Céges adatok módosítása</h3>
        <div className="input-group">
          <label htmlFor="companyName">Cég neve </label>
          <input
            type="text"
            id="companyName"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="Cég neve"
          />
        </div>
        <div className="input-group">
          <label htmlFor="companyLocation">Cég helye </label>
          <input
            type="text"
            id="companyLocation"
            value={companyLocation}
            onChange={(e) => setCompanyLocation(e.target.value)}
            placeholder="Céghely"
          />
        </div>
        <div className="input-group">
          <label htmlFor="email">Cég email</label>
          <input
            type="text"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />
        </div>
        <div className="input-group">
          <label htmlFor="companylogo">Cég logó, internetes link </label>
          <input
            type="url"
            id="companylogo"
            value={companyLogo}
            onChange={(e) => setCompanyLogo(e.target.value)}
            placeholder="Cég logó internetes link: https://cégweboldal .... .png .jpg stb."
          />
        </div>
        <label htmlFor="companylogo">Cég logó, kép feltöltése</label>
        <input className="custom-button-invert" type="file" onChange={handleFileSelect} />

          <div className="input-group"></div>
  
        <div className={desktopView ? "footer-desktop" : "footer"}>
          <button className="back-button" onClick={navigateToCreateJob}>
            Vissza a hirdetés feladás oldalra
          </button>
          <button className="apply-button" onClick={handleSubmit}>
            Cég adatok mentése
          </button>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <NewClientRequest/>  
    );
  }
};

export default UpdateCompany;
